import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "kx_token";

export const api = axios.create({ baseURL: BASE });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("kx-logout"));
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "İşlem başarısız") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};

export const downloadFile = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};

export const money = (n, currency = "TRY") =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency, maximumFractionDigits: 0 }).format(n || 0);
export const shortNum = (n) => {
  const abs = Math.abs(n || 0);
  if (abs >= 1e9) return (n / 1e9).toFixed(1) + " Mrd";
  if (abs >= 1e6) return (n / 1e6).toFixed(1) + " M";
  if (abs >= 1e3) return (n / 1e3).toFixed(0) + " B";
  return String(n || 0);
};
export const CURRENCIES = ["TRY", "USD", "EUR"];
export const COMPANIES = ["REEN Enerji", "REEN MT Project"];
export const PROJECT_STATUSES = ["Planlama", "Teklif", "Devam Ediyor", "Askıda", "Tamamlandı"];
export const ROLE_LABELS = { super_admin: "Ana Yönetici", admin: "Yönetici", project_manager: "Proje Yöneticisi", finance: "Finans", calisan: "Çalışan" };
export const STAGES = ["Avans", "1. Ödeme", "2. Ödeme", "3. Ödeme", "4. Ödeme", "Tahsilat", "Ödeme"];
export const PAY_STATUSES = ["Ödendi", "Planlanan", "Bekliyor"];
